import { Backdrop, Typography } from "@mui/material";

export default function LoadingScreen() {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open
    >
      <Typography
        style={{
          position: "absolute",
          top: "55%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
        className="main__loader"
      >
        Loading
      </Typography>
    </Backdrop>
  );
}
